<template>
  <div class="mobile-divider" />
</template>
<script>
export default {
  // eslint-disable-next-line vue/name-property-casing
  name: 'mobile-divider',
  props: {
    text: {
      type: String,
      default: ''
    }
  },
  data() {
    return {

    }
  }
}
</script>
<style lang="less" scoped>
.mobile-divider{
  width: 100%;
  height: .75rem;
  background-color: #F1F1F1;
}
</style>




// WEBPACK FOOTER //
// src/components/mobile-divider/index.vue